import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AdminLayout from './admin/AdminLayout'

// Import all admin pages
import AdminIndex from './admin/index'
import SchoolsAdmin from './admin/schools/index'
import CitiesAdmin from './admin/cities/index'
import AreasAdmin from './admin/areas/index'
import ReviewsAdmin from './admin/reviews/index'
import ClaimsAdmin from './admin/claims/index'
import WebsiteSyncAdmin from './admin/website-sync/index'
import JobsAdmin from './admin/jobs/index'
import QAAdmin from './admin/qa/index'
import CounsellorsAdmin from './admin/counsellors/index'
import InstaStories from './admin/instastories/index';
import FbFormMappingsAdmin from './admin/fb-form-mappings/index'
import GoogleCampaignMappingsAdmin from './admin/google-campaign-mappings/index'
import ClientsAdmin from './admin/clients/index'
import YoutubeVideosAdmin from './admin/youtube-videos/index'
import BlogMisinformationAdmin from './admin/blog-misinformation/index'
import ParentAppAdmin from './admin/parent-app/index'
import WhatsAppInbox from './admin/whatsapp-inbox/index'
import CommunityModerationAdmin from './admin/community/index'

const Admin: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<AdminIndex />} />
        <Route path="schools" element={<SchoolsAdmin />} />
        <Route path="cities" element={<CitiesAdmin />} />
        <Route path="areas" element={<AreasAdmin />} />
        <Route path="reviews" element={<ReviewsAdmin />} />
        <Route path="claims" element={<ClaimsAdmin />} />
        <Route path="website-sync" element={<WebsiteSyncAdmin />} />
        <Route path="jobs" element={<JobsAdmin />} />
        <Route path="qa" element={<QAAdmin />} />
        <Route path="counsellors" element={<CounsellorsAdmin />} />
        <Route path="instastories" element={<InstaStories />} />
        <Route path="fb-form-mappings" element={<FbFormMappingsAdmin />} />
        <Route path="google-campaign-mappings" element={<GoogleCampaignMappingsAdmin />} />
        <Route path="clients" element={<ClientsAdmin />} />
        <Route path="youtube-videos" element={<YoutubeVideosAdmin />} />
        <Route path="blog-misinformation" element={<BlogMisinformationAdmin />} />
        <Route path="parent-app" element={<ParentAppAdmin />} />
        <Route path="whatsapp-inbox" element={<WhatsAppInbox />} />
        <Route path="community" element={<CommunityModerationAdmin />} />
      </Route>
    </Routes>
  )
}

export default Admin
